"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectMenu = void 0;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const components_1 = require("utils/components");
const models_hook_1 = require("app/models.hook");
const auth_1 = require("common/auth");
const routes = __importStar(require("../../../pages/modules"));
const wordTable_1 = require("@/schemaComponents/modules/hooks/wordTable");
const index_1 = require("../../index");
const ProjectMenu = ({ projectId }) => {
    const { pathname } = (0, react_router_dom_1.useLocation)();
    const { projectRole } = (0, auth_1.useProjectPageAuthorization)(projectId);
    const isMaster = projectRole === "master";
    const { data, loading } = (0, models_hook_1.useProjectDoc)({ projectId });
    // wordTableの先読みとキャッシュの維持を目的としてこの位置で呼び出している
    (0, wordTable_1.useProjectWordTable)(projectId);
    if (!projectId)
        return react_1.default.createElement("div", null, "Internal error");
    const logoUrl = data === null || data === void 0 ? void 0 : data.logoUrl;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "menu is-menu-main" },
            react_1.default.createElement("ul", { className: "menu-list" },
                react_1.default.createElement(components_1.Link, { to: (0, index_1.resolveRoute)("LIST_PROJECTS") },
                    react_1.default.createElement(components_1.Button, { variant: "light", size: "lg", width: "full" },
                        react_1.default.createElement("span", { className: "icon" },
                            react_1.default.createElement("i", { className: "mdi mdi-arrow-right-top", style: { transform: "rotate(-0.25turn)" } })),
                        "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u4E00\u89A7\u306B\u623B\u308B")),
                react_1.default.createElement(components_1.Link, { to: (0, index_1.resolveRoute)("LIST_SEGMENTS", { projectId }) },
                    react_1.default.createElement(components_1.Button, { width: "full", size: "lg", variant: "light" },
                        react_1.default.createElement("span", { className: "icon" },
                            react_1.default.createElement("i", { className: "mdi mdi-store" })),
                        react_1.default.createElement("span", { className: "menu-item-label" }, "\u7FFB\u8A33\u30D5\u30A1\u30A4\u30EB\u4E00\u89A7"))),
                react_1.default.createElement(components_1.Link, { to: (0, index_1.resolveRoute)("SEGMENT_RESTORATION", { projectId }) },
                    react_1.default.createElement(components_1.Button, { width: "full", size: "lg", variant: "light" },
                        react_1.default.createElement("span", { className: "icon" },
                            react_1.default.createElement("i", { className: "mdi mdi-restore" })),
                        react_1.default.createElement("span", { className: "menu-item-label" }, "\u30D5\u30A1\u30A4\u30EB\u5FA9\u5143"))),
                react_1.default.createElement(components_1.Link, { to: (0, index_1.resolveRoute)("LIST_LANGS", { projectId }), className: routes.UPDATE_LANG.match(pathname) ||
                        routes.ADD_LANG.match(pathname)
                        ? "navbar-item is-edit"
                        : undefined },
                    react_1.default.createElement(components_1.Button, { width: "full", size: "lg", variant: "light" },
                        react_1.default.createElement("span", { className: "icon" },
                            react_1.default.createElement("i", { className: "mdi mdi-store" })),
                        react_1.default.createElement("span", { className: "menu-item-label" }, "\u8A00\u8A9E\u4E00\u89A7"))),
                react_1.default.createElement(components_1.Link, { to: (0, index_1.resolveRoute)("WORD_TABLE", { projectId }) },
                    react_1.default.createElement(components_1.Button, { width: "full", size: "lg", variant: "light" },
                        react_1.default.createElement("span", { className: "icon" },
                            react_1.default.createElement("i", { className: "mdi mdi-book-open" })),
                        react_1.default.createElement("span", { className: "menu-item-label" }, "\u5358\u8A9E\u30EA\u30B9\u30C8"))),
                isMaster && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("span", { style: {
                            textAlign: "center",
                            color: "#eee",
                            marginTop: 60,
                            marginBottom: 5,
                            marginLeft: 5,
                            whiteSpace: "nowrap",
                        } }, "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u7BA1\u7406\u8005\u30E1\u30CB\u30E5\u30FC"),
                    react_1.default.createElement(components_1.Link, { to: (0, index_1.resolveRoute)("UPDATE_PROJECT", { projectId }) },
                        react_1.default.createElement(components_1.Button, { width: "full", size: "lg", variant: "light" },
                            react_1.default.createElement("span", { className: "icon" },
                                react_1.default.createElement("i", { className: "mdi mdi-pencil" })),
                            react_1.default.createElement("span", { className: "menu-item-label" }, "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u60C5\u5831"))),
                    react_1.default.createElement(components_1.Link, { to: (0, index_1.resolveRoute)("LIST_PROJECT_USER_AUTH", { projectId }), className: routes.UPDATE_PROJECT_USER_AUTH.match(pathname) ||
                            routes.CREATE_PROJECT_USER_AUTH.match(pathname)
                            ? "navbar-item is-edit"
                            : undefined },
                        react_1.default.createElement(components_1.Button, { width: "full", size: "lg", variant: "light" },
                            react_1.default.createElement("span", { className: "icon" },
                                react_1.default.createElement("i", { className: "mdi mdi-store" })),
                            react_1.default.createElement("span", { className: "menu-item-label" }, "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u30E6\u30FC\u30B6\u4E00\u89A7")))))))));
};
exports.ProjectMenu = ProjectMenu;
